import { render } from "./ErrorModalComponent.vue?vue&type=template&id=2c9183ae"
import script from "./ErrorModalComponent.vue?vue&type=script&lang=js"
export * from "./ErrorModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__